import { BaseApi } from "../shared/api";
import * as sharedTypes from "../shared/actionTypes";
import * as types from "./actionTypes";
import * as url from "./apiUrls";

import {
  startLoading,
  stopLoading,
  showErrors,
} from '../shared/actions';

function startLoanOffersLoading() {
  return { type: types.LOAN_OFFER_LOADING_START };
}

function stopLoanOffersLoading() {
  return { type: types.LOAN_OFFER_LOADING_STOP };
}

function receiveLoanOffers(loanOffers) {
  return { type: types.LOAN_OFFERS_FETCH_SUCCESS, payload: loanOffers };
}

function receiveUpcomingPayments(payments) {
  return { type: types.RECEIVE_UPCOMING_PAYMENTS, payload: payments};
}

export function fetchLoanOffers() {
  return (dispatch, getState) => {
    dispatch(startLoanOffersLoading());
    const user = getState().user;

    if(!user || !user.id) {
      dispatch(stopLoanOffersLoading());
      dispatch(showErrors({status: '', statusText: 'Unable to fetch Loan Offers'}));
      return;
    }

    const api = new BaseApi(dispatch, getState);

    return api.getRequest(
      url.activeLoanOffers(user.id),
      response => {
        if(response.data instanceof Array) dispatch(receiveLoanOffers(response.data));
        dispatch(stopLoanOffersLoading());
      }
    )
  }
}

export function fetchUpcomingPayments(page=1,
                                      per_page=100,
                                      onSuccess = () => {}) {
  return (dispatch, getState) => {
    dispatch(startLoading('upcomingPayments'));
    const { company } = getState();
    if(!company) return;
    let api, apiUrl;

    api = new BaseApi(dispatch, getState, {
      headers: { 'x-api-key': process.env.REACT_APP_LMS_API_KEY }
    });
    apiUrl = url.upcomingPayments(company.id, {
      page,
      per_page
    });

    return api.getRequest(
      apiUrl,
      response => {
        onSuccess(response);
        dispatch(receiveUpcomingPayments(response.data.data.map(r => r.attributes)));
        dispatch(stopLoading('upcomingPayments'));
      },
      errors => {
        dispatch({
          type: sharedTypes.HANDLE_ERRORS,
          payload: {
            data: {},
            header: "Oops, something went wrong",
            body: "We are unable to show you your credit limit and upcoming payments (if any). Please contact Support for help.",
              duration: -1,
          }
        });
      }
    )
  };
}



// WEBPACK FOOTER //
// ./src/features/loans/actions.js